import { User, UserManager, UserManagerSettings } from "oidc-client";
import {
  IUserAuthentication,
  IUserProfile,
} from "@centraldispatch/singlespa-utilities";
import { UserProfile } from "./user";
import { navigateToUrl } from "single-spa";

export interface IAuthenticator extends IUserAuthentication {
  loginSilentAsync(): Promise<User>;
  handleLoginCallbackAsync(): Promise<IUserProfile>;
  handleSilentRenewCallbackAsync(): Promise<void>;
}

export class Authenticator implements IAuthenticator {
  private static instance: Authenticator;
  private readonly manager: UserManager;

  constructor(manager: UserManager) {
    this.manager = manager;
  }

  static getInstance = (settings: UserManagerSettings): Authenticator => {
    if (!Authenticator.instance) {
      Authenticator.instance = new Authenticator(new UserManager(settings));
    }

    return Authenticator.instance;
  };

  public getUserManager = (): UserManager => {
    return this.manager;
  };

  public loginAsync = async (): Promise<void> => {
    const args = {
      state: window.location.pathname + window.location.search,
    };

    await this.manager.signinRedirect(args);
  };

  public logoutAsync = async (): Promise<void> => {
    await this.manager.signoutRedirect();
  };

  public loginSilentAsync = async (): Promise<User> => {
    return await this.manager.signinSilent();
  };

  public handleLoginCallbackAsync = async (): Promise<IUserProfile> => {
    const user = await this.manager.signinRedirectCallback();

    if (user.state?.length) {
      navigateToUrl(user.state);
    }

    const userProfile = new UserProfile(user.profile, user.access_token);

    return userProfile;
  };

  public handleSilentRenewCallbackAsync = async (): Promise<void> => {
    await this.manager.signinSilentCallback();
  };

  public switchAccounts = (): void => {
    const redirectUrl = btoa(
      `https://${window.location.host}/switch-accounts?app=${window.location.pathname}`
    );

    window.location.href = `${process.env.IDENTITY_URL}/AccountSelector?redirectUrl=${redirectUrl}&clientId=${process.env.IDENTITY_CLIENT_ID}`;
  };
}
